import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import AuthLayout from "./AuthLayout";
import { sendOtp, changeForgetPassword } from "../../api/auth";

export default function ForgotPassword() {
	const { state } = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState(state?.email || "");
	const step = state?.step || "request"; // "request" | "reset"

	const requestOtp = async (e) => {
		e.preventDefault();
		if (!email) {
			toast.error("Enter your email");
			return;
		}
		setLoading(true);
		const res = await sendOtp({ email: email.toLowerCase() });
		setLoading(false);
		if (res && !res.error) {
			navigate("/verify-otp", { state: { email: email.toLowerCase(), purpose: "forgot-password" } });
		} else {
			toast.error(res?.msg || "Could not send OTP");
		}
	};

	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const resetPassword = async (e) => {
		e.preventDefault();
		if (password.length < 8) {
			toast.error("Password must be at least 8 characters");
			return;
		}
		if (password !== confirmPassword) {
			toast.error("Passwords must match");
			return;
		}
		setLoading(true);
		const res = await changeForgetPassword({ email: state.email, password, confirmPassword, otp: state.otpToken });
		setLoading(false);
		if (res && !res.error) {
			toast.success("Password updated. Please log in.");
			navigate("/login");
		} else {
			toast.error(res?.msg || "Could not reset password");
		}
	};

	if (step === "reset" && state?.email) {
		return (
			<AuthLayout heading="Set a new password" subheading={`For ${state.email}`}>
				<form onSubmit={resetPassword}>
					<div className="mb-2">
						<label className="form-label">New password</label>
						<input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
					</div>
					<div className="mb-3">
						<label className="form-label">Confirm password</label>
						<input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
					</div>
					<button className="btn-accent-solid w-100" disabled={loading}>
						{loading ? "Saving..." : "Reset Password"}
					</button>
				</form>
			</AuthLayout>
		);
	}

	return (
		<AuthLayout heading="Forgot password" subheading="We'll send a verification code to your email">
			<form onSubmit={requestOtp}>
				<div className="mb-3">
					<label className="form-label">Email</label>
					<input className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
				</div>
				<button className="btn-accent-solid w-100" disabled={loading}>
					{loading ? "Sending..." : "Send Code"}
				</button>
				<div className="text-center mt-4 small">
					<Link to="/login">Back to login</Link>
				</div>
			</form>
		</AuthLayout>
	);
}
